import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

import { MODULE_KEY, ROLES_KEYS } from '@interfaces';
import { StackedMessagesService } from '@shared/stacked-messages/stacked-messages.service';
import { UserAuthFacade } from '@state/user-auth';
import { SystemSettingsFacade } from '@state/system-settings';

@Injectable()
export class FeatureModuleGuard {
  private readonly systemSettingsFacade = inject(SystemSettingsFacade);
  private readonly notifService = inject(StackedMessagesService);
  private readonly router = inject(Router);

  // !IMPORTANT - this works only for authorized users

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    // Get route data to check the key of module we want to check access for
    // Fetch data from the systemSettings facade observable
    // If the module is enabled - let user in
    // if the moduleKey does not exist in the systemSettings - let user In
    // if the module is disabled - silently redirect to the root of the app

    const moduleKey = route.data['moduleKey'] as MODULE_KEY;
    const exitUrlTree = this.router.createUrlTree(['/']);
    return this.systemSettingsFacade.modulesConfiguration$.pipe(
      filter(modulesConfiguration => !!modulesConfiguration), // Ensure that we have the modules configuration loaded
      take(1),
      switchMap(modulesConfiguration => {
        // If moduleKey does not exist, we consider it as enabled
        const isModuleEnabled = modulesConfiguration[moduleKey] !== undefined ? modulesConfiguration[moduleKey] : true;
        if (isModuleEnabled) {
          return of(true);
        }
        return of(exitUrlTree);
      })
    );
  }
}
